import {gql} from "@apollo/client";

export const GET_GENERATEPRESIGNEDURL = gql`
	query GeneratePreSignedUrl($documentUrl: String!) {
		generatePreSignedUrl(documentUrl: $documentUrl) {
			url
		}
	}
`;

export const GET_ORDER = gql`
	query GetOrderDetail(
		$id: UUID!
	) {
		orderDetails(
			where:{
				id:{ eq: $id }
			}
		) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					userDesiresIncentive
					transactionDate
					orderRequestS3Path
					providerResultS3Path
					policyS3Path
					requestId
					policyId
					apiClientName
					status
					orderType
					webhookProvider
					senderId
					googleAnalyticsId
					googleAnalyticsSessionId
					metaFbc
					metaFbp
					ipAddress
					processReference
					financial {
						financialStatus
						totalCommission
						partnerCommission
						kiziCommission
						customProperties
						{
							financialStatusChangeDate
						}
					}
					mainApplicant {
						address {
							addressType
							city
							country
							houseNumber
							houseNumberAddition
							id
							postalCode
							street
						}
						bsn
						nationality
						prefixes
						birthdate
						callName
						email
						genderOrLegalPersonType
						initials
						mobile
						surname
						workPhoneNumber
						customProperties {
							consumentenbondMember
							consumentenbondUserId
						}
					}
					paymentDetails {
						collectionAccountIban
						paymentMethod
						paymentTermInMonths
					}
					package {
						offerNumber
						companyNameDescription
						customProperties {
							affiliateUrl
							externalId
							productKrn
							providerKrn
							supplierKrn
						}
						deductibleAmount
						effectiveDate
						externalSourceName
						productDescription
						totalInstallmentAmount
						policyDetails {
							refKey
							contractNumber
							companyNameDescription
							oneOffCostsAmount
							totalInstallmentAmount
							productName
							productDescription
							deductibleAmount
							coverageBuildings {
								coverageCode
							}
							coverageHomes {
								coverageCode
							}
							coverageAdditionalHealths {
								deductibleAmount
								deductibleDiscountAmount
							}
							coverageBasicHealths {
								deductibleDiscountAmount
								deductibleAmount
							}
							coverageDentistHealths {
								deductibleAmount
								deductibleDiscountAmount
							}
							customProperties {
								productKrn
								externalId
								affiliateId
								validationDate
							}
							partyPolicyHolders {
								address {
									addressType
									city
									country
									houseNumber
									houseNumberAddition
									id
									postalCode
									street
								}
								bsn
								nationality
								prefixes
								birthdate
								callName
								email
								genderOrLegalPersonType
								initials
								mobile
								surname
								workPhoneNumber
								customProperties {
									consumentenbondMember
									consumentenbondUserId
								}
								
							}
							partyPartners {
								address {
									addressType
									city
									country
									houseNumber
									houseNumberAddition
									id
									postalCode
									street
								}
								bsn
								nationality
								prefixes
								birthdate
								callName
								email
								genderOrLegalPersonType
								initials
								mobile
								surname
								workPhoneNumber
								customProperties {
									consumentenbondMember
									consumentenbondUserId
								}
								
							}
							partyChildren {
								address {
									addressType
									city
									country
									houseNumber
									houseNumberAddition
									id
									postalCode
									street
								}
								bsn
								nationality
								prefixes
								birthdate
								callName
								email
								genderOrLegalPersonType
								initials
								mobile
								surname
								workPhoneNumber
								customProperties {
									consumentenbondMember
									consumentenbondUserId
								}
								
							}
							financial {
								financialStatus
								totalCommission
								partnerCommission
								kiziCommission
							}
						}
						documents {
							attachmentType
							documentUrl
							fileExtension
							fileName
						}
					}
					houseInformation{
						address {
							addressType
							city
							country
							houseNumber
							houseNumberAddition
							id
							postalCode
							street
						}
						constructionYear
						homeType
						propertyOfInsured
					}
					productCategory
					familyComposition
					underwritingResult
					urmSource
					note
					userId
					comparatorId
					sessionId
					comparisonId
				}
			}
		}
	}
`;

export const GET_ORDERS = gql`
	query GetOrderDetail($first: Int, $after: String, $where: OrderLookupFilterInput, $order: [OrderLookupSortInput!])
	{
		orderDetails(
			first: $first
			after: $after
			where: $where
			order: $order
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				supplierName
				userDesiresIncentive
				entityType
				surname
				email
				creationDateTime
				creationDateTimeString
				transactionDate
				googleAnalyticsId
				googleAnalyticsSessionId
				metaFbc
				metaFbp
				ipAddress
				orderRequestS3Path
				policyS3Path
				providerResultS3Path
				requestId
				policyId
				apiClientName
				status
				orderType
				processReference
				productCategory
				familyComposition
				underwritingResult
				urmSource
				note
				userId
				comparatorId
				sessionId
				comparisonId
				webhookProvider
				senderId
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
				financial {
					financialStatus
					totalCommission
					partnerCommission
					kiziCommission
					customProperties {
						financialStatusChangeDate
					}
				}
				mainApplicant {
					prefixes
					initials
					callName
					surname
					genderOrLegalPersonType
					workPhoneNumber
					mobile
					email
					birthdate
					address {
						postalCode
						houseNumber
						houseNumberAddition
						street
						city
					}
					customProperties {
						consumentenbondMember
						consumentenbondUserId
					}
				}
				paymentDetails {
					collectionAccountIban
					paymentTermInMonths
					paymentMethod
				}
				package {
					companyNameDescription
					productDescription
					customProperties {
						providerKrn
						productKrn
					}
				}
				houseInformation {
					address {
						postalCode
					}
				}
			}
		}
	}
`;

export const GET_ORDERS_WITH_INCENTIVE = gql`
	query GetOrderDetail(
		$first: Int
		$after: String
		$where: OrderLookupFilterInput
	)
	{
		orderDetails(
			first: $first
			after: $after
			where: $where
			order: {
				transactionDate: DESC
			}
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				creationDateTime
				status
				underwritingResult
				userDesiresIncentive
				apiClientName
				mainApplicant {
					callName
					email
				}
				package {
					companyNameDescription
				}
			}
		}
	}
`;

export const GET_ORDER_NOTIFICATIONS = gql`
	query GetOrderNotifications($orderId: UUID!) {
		orderNotifications(
			where:{
				orderId: { eq: $orderId }
			}
		) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					orderId
					creationDateTime
					notificationType
					notificationValues
				}
			}
		}
	}
`;

export const GET_PRODUCTS_WITH_SUPPLIERS = gql`
	query GetProductsWithSuppliers($productKrns: [String!]!, $productCategory: ProductCategory!) {
		productsWithSuppliers(productKrns: $productKrns, productCategory: $productCategory) {
			products {
				id
				krn
				name
				state
				externalId
				affiliateUrl
			}
		}
	}
`;

export const GET_EXTERNAL_ORDER_DATA = gql`
	query GetExternalOrderData($ids: [UUID!]) {
		externalOrderDataAsync
		(
			where: {
				id: { in: $ids }
			}
		) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					creationDateTime
					zorgWebApplication {
						requestMoment
						addressInfo {
							address {
								street
								houseNumber
								country
								city
								email
								houseNoAddition
								postcode
								telephoneNumber
							}
						}
						applicant {
							bsn
							dateOfBirth
							gender
							initials
							nationality
							surname
							selectedPackage {
								collectiveDiscount
								employerContribution
								ownRisk
								packageId
								insurer
								mainInsurer
								productCodes
								insurerCode
								uniqueHealthcareInsurersIdentification
								year
								insurances {
									insurance {
										id
										name
										urlPolicyCard
										zorgWebCode
										premiums {
											premiumApplicant {
												bsn
												premiumGeneralInsurance
												premiumSupplementaryInsurance
											}
											basePremium
											discountCollective
											discountDeductible
											grossHeadInsurance
											discountPaymentTerm
											municipalContribution
											municipalReturn
											ownRisk
											total
											totalDiscounts
											totalGeneralInsurance
											totalWithDiscounts
											totalWithoutDiscounts
											totalExceptDiscountPaymentTerm
											premiumPartner {
												premiumSupplementaryInsurance
												premiumGeneralInsurance
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const GET_BATCH_ITEMS = gql`
	query GetBatchItems($orderId: String!) {
		batchItems(
			where:{
				itemId: { eq: $orderId }
			}
			order: {
				processDate: DESC
			}
		) {
			edges {
				node {
					id
					itemId
					batchItemType
					processDate
					completed
					status
					note
				}
			}
		}
	}
`;

export const GET_EXTERNAL_CALLS = gql`
	query ExternalCalls($orderId: UUID!) {
		externalCalls(orderId: $orderId)
	}
`;

export const GET_ERRORS = gql`
	query GetErrors($orderId: UUID!) {
		errors(orderId: $orderId)
	}
`;

export const UPDATE_UNDERWRITING_RESULT_BY_ORDER_IDS = gql`
	mutation UpdateUnderwritingResultByOrderIds($orderIds: [UUID!]!, $underwritingResult: UnderwritingResult!) {
		updateUnderwritingResultByOrderIds(orderIds: $orderIds, underwritingResult: $underwritingResult) {
			orderIds
		}
	}
`;

export const REQUEST_ORDER_SUMMARY_EXPORT = gql`
	mutation RequestOrderSummaryExport($orderSummaryExportRequest: ExportRequestInput!) {
		requestOrderSummaryExport(orderSummaryExportRequest: $orderSummaryExportRequest) {
			queued
			errors {
				message
			}
		}
	}
`;
